function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { css } from 'styled-components';
import Auto from './cursors/Arrow.png';
import Text from './cursors/Text.png';
import VerticalText from './cursors/VText.png';
import Help from './cursors/Help.png';
import Crosshair from './cursors/Cross.png';
import Pointer from './cursors/HandPointer.png';
import Progress from './cursors/AppStarting.png';
import Wait from './cursors/Wait.png';
import Alias from './cursors/Link.png';
import Copy from './cursors/Copy.png';
import Move from './cursors/Move.png';
import NoDrop from './cursors/Circle.png';
import NotAllowed from './cursors/NO.png';
import Grab from './cursors/Hand.png';
import Grabbing from './cursors/Handsqueezed.png';
import ColResize from './cursors/ColRezise.png';
import RowResize from './cursors/RowResize.png';
import NResize from './cursors/UpArrow.png';
import EResize from './cursors/RightArrow.png';
import SResize from './cursors/DownArrow.png';
import WResize from './cursors/LeftArrow.png';
import NsResize from './cursors/UpDownArrow.png';
import EwResize from './cursors/LeftRight.png';
import NeResize from './cursors/UpRightArrow.png';
import NwResize from './cursors/UpLeftArrow.png';
import SeResize from './cursors/DownRightArrow.png';
import SwResize from './cursors/DownLeftArrow.png';
import NeswResize from './cursors/AngleUpRight.png';
import NwseResize from './cursors/AngleUpLeft.png';
import ZoomIn from './cursors/ZoomIn.png';
import ZoomOut from './cursors/ZoomOut.png';
var cursors = {
  Auto: Auto,
  Text: Text,
  VerticalText: VerticalText,
  Help: Help,
  Crosshair: Crosshair,
  Pointer: Pointer,
  Progress: Progress,
  Wait: Wait,
  Alias: Alias,
  Copy: Copy,
  Move: Move,
  None: null,
  NoDrop: NoDrop,
  NotAllowed: NotAllowed,
  Grab: Grab,
  Grabbing: Grabbing,
  ColResize: ColResize,
  RowResize: RowResize,
  NResize: NResize,
  EResize: EResize,
  SResize: SResize,
  WResize: WResize,
  NsResize: NsResize,
  EwResize: EwResize,
  NeResize: NeResize,
  NwResize: NwResize,
  SeResize: SeResize,
  SwResize: SwResize,
  NeswResize: NeswResize,
  NwseResize: NwseResize,
  ZoomIn: ZoomIn,
  ZoomOut: ZoomOut
};

var toKebabCase = function toKebabCase(str) {
  return "".concat(str.charAt(0).toLowerCase()).concat(str.substring(1)).replace(/[A-Z]/g, function (letter) {
    return "-".concat(letter.toLowerCase());
  });
};

var Cursor = Object.keys(cursors).reduce(function (all, cur) {
  return Object.assign(all, _defineProperty({}, cur, css(["cursor:", " ", ";"], cursors[cur] && "url(".concat(cursors[cur], "), "), toKebabCase(cur))));
}, {});
export default Cursor;